module.exports = __webpack_public_path__ + "img/topicMobility.e198978d.webp";